"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueSupplierEnum = void 0;
var ValueSupplierEnum;
(function (ValueSupplierEnum) {
    /**
     * 参数接受输入
     * - 部件的参数，只有接受输入，才能被上层更改参数来源
     */
    ValueSupplierEnum["Input"] = "input";
    /**
     * 可选地输入，可被上层更改参数来源
     */
    ValueSupplierEnum["PickUp"] = "pick-up";
    /** 指定值（无需输入） */
    ValueSupplierEnum["Specified"] = "specified";
    /** 使用空值 */
    ValueSupplierEnum["Empty"] = "empty";
    /** 系统生成 */
    ValueSupplierEnum["System"] = "system";
    /** 引用上层参数 */
    ValueSupplierEnum["Borrow"] = "borrow";
    /** 发货回填（意味着订购时值可以为空） */
    ValueSupplierEnum["Shipping"] = "shipping";
    /** 其他参数项的乘积（仅限自身） */
    ValueSupplierEnum["Multiplication"] = "multiplication";
    /** 其他参数项的和 */
    ValueSupplierEnum["Sum"] = "sum";
    /** 最大值 */
    ValueSupplierEnum["Max"] = "max";
    /** 最小值 */
    ValueSupplierEnum["Min"] = "min";
    /** 整数除法（向下取整） */
    ValueSupplierEnum["IntDivFloor"] = "int-div-floor";
    /** 整数除法（向上取整） */
    ValueSupplierEnum["IntDivCeiling"] = "int-div-ceiling";
})(ValueSupplierEnum || (exports.ValueSupplierEnum = ValueSupplierEnum = {}));
